import { render, staticRenderFns } from "./VFormComment.vue?vue&type=template&id=29b8d15a&scoped=true&"
import script from "./VFormComment.vue?vue&type=script&lang=js&"
export * from "./VFormComment.vue?vue&type=script&lang=js&"
import style0 from "./VFormComment.vue?vue&type=style&index=0&id=29b8d15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b8d15a",
  null
  
)

export default component.exports